import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getFormasEnvio, setFormaEnvio } from '../../actions/formasEnvio'
import i18n from '../../lang/idiomas'

const PortesCasals = ({ pedidoGuardado }) => {
  const dispatch = useDispatch()
  const pedido_cargando = useSelector(state => state.pedidos.isLoading)
  const pedido = useSelector(state => state.pedidos.pedido)
  const formas_envio = useSelector(state => state.formasEnvio.formas_envio)
  const forma_envio = useSelector(state => state.formasEnvio.forma_envio)
  const user = useSelector(state => state.auth.user)

  const minPortes = parseFloat(user?.reservado_number_1 ?? 0) || 0
  const totalPedido =
    pedido?.total_pedido != null
      ? parseFloat(pedido.total_pedido)
      : (pedido?.lineas
          ?.filter(l => l.tipo_linea === 'P')
          .reduce((acc, l) => acc + parseFloat(l.importe_neto_lin || 0), 0) ?? 0)

  // Caso 1825003: si el usuario no tiene umbral de portes (reservado_number_1
  // a 0 o nulo), cualquier pedido va a portes pagados. Se espera a tener el
  // usuario cargado para no forzar 'P' mientras llega.
  const portesGratis = !!user && (minPortes <= 0 || totalPedido >= minPortes)

  useEffect(() => {
    dispatch(getFormasEnvio())
  }, [])

  useEffect(() => {
    if (!formas_envio?.length) return

    // Portes gratis alcanzados: forzamos 'P'
    if (portesGratis) {
      const formaP = formas_envio.find(f => f.forma_envio === 'P')
      if (formaP) dispatch(setFormaEnvio(formaP))
      return
    }

    // Sin nada seleccionado (o veníamos de 'P'): la del pedido guardado, y
    // si no, 'D' (Portes Debidos), que es el defecto que quiere Casals.
    if (!forma_envio?.forma_envio || forma_envio.forma_envio === 'P') {
      const formaPedido =
        pedido?.forma_envio === 'C' || pedido?.forma_envio === 'D'
          ? formas_envio.find(f => f.forma_envio === pedido.forma_envio)
          : null
      const formaDefecto =
        formaPedido ||
        formas_envio.find(f => f.forma_envio === 'D') ||
        formas_envio.find(f => f.forma_envio === 'C')
      if (formaDefecto) dispatch(setFormaEnvio(formaDefecto))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalPedido, formas_envio, portesGratis])

  const handleChange = e => {
    const forma = formas_envio.find(f => f.forma_envio === e.target.value)
    if (forma) dispatch(setFormaEnvio(forma))
  }

  const opcionesDisponibles = portesGratis
    ? formas_envio.filter(f => f.forma_envio === 'P')
    : formas_envio.filter(f => f.forma_envio === 'C' || f.forma_envio === 'D')

  return (
    <form className='form-default'>
      <div className='form-group'>
        <label htmlFor='tipo_portes'>{i18n.t('formas.forenmay', 'FORMA ENVÍO *')}</label>
        <select
          className='form-control'
          id='tipo_portes'
          name='tipo_portes'
          value={portesGratis ? 'P' : forma_envio?.forma_envio || 'D'}
          onChange={handleChange}
          disabled={pedidoGuardado || pedido_cargando || portesGratis}>
          {opcionesDisponibles.map(f => (
            <option
              key={f.forma_envio}
              value={f.forma_envio}>
              {f.descripcion}
            </option>
          ))}
        </select>
        {!portesGratis && (
          <small className='form-text text-muted'>
            {i18n.t(
              'portes.porayuda',
              'Portes - Cargados en factura Sólo con G.L.S (ASM), DHL y Tourline. El resto de agencias a portes debidos y estas deben ser avisadas por el cliente para la recogida. Envío exclusivamente por DHL cuando se alcance la cantidad para portes pagados por Casals.',
            )}
          </small>
        )}
      </div>
    </form>
  )
}

export default PortesCasals
